import { memo, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTaiKhoan } from 'src/stores';
import { IBaseProps } from 'src/types/common.type';
import { ELoaiTaiKhoan } from 'src/types/enum';
import { Routes } from './route';

function RouteGuard({ children }: IBaseProps) {
  const { taiKhoan } = useTaiKhoan();
  const { pathname } = useLocation();

  const passed = useMemo<boolean>(() => {
    if (!taiKhoan) return false;

    if (taiKhoan.LoaiTaiKhoan !== ELoaiTaiKhoan.AdminTong) {
      // @ts-ignore
      // const route: IRoute = Routes[Object.keys(Routes).find((key: string) => Routes[key].path === pathname)];
      //   return false;
      // }
    }

    return true;
  }, [taiKhoan, pathname]);

  if (!taiKhoan) return <Navigate to={Routes.LOGIN.path as string} />;

  if (!passed) return <Navigate to={Routes.PAGE403.path as string} />;

  return children;
}

export default memo(RouteGuard);
